module.exports = __webpack_public_path__ + "media/images/flags/16/Taiwan-f52cf3b5d8b61585ddae557870362868.png";